import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { toastError, toastSuccess } from "../../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../../common/Constant";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import config from "../../../config/config";
import EmployeeCustomFieldCard from "./EmployeeCustomFieldCard";

const CustomFieldConfigEmployee = (props) => {
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const [cardData, setCardData] = useState([
    {
      Id: 0,
      Name: "",
      TypeId: 1,
      Optionvalue: "",
      ShowOnReceipt: 0,
      HideFieldLabel: 0,
      Required: 0,
      Locations: "",
    },
  ]);

  const addCard = () => {
    const cardInput = {
      Id: 0,
      Name: "",
      TypeId: 1,
      Optionvalue: "",
      ShowOnReceipt: 0,
      HideFieldLabel: 0,
      Required: 0,
      Locations: "",
    };

    setCardData([...cardData, cardInput]);
  };

  const handleChangeCard = (index, evnt) => {
    // console.log(evnt.target.checked);
    console.log(evnt.target);

    let name, values;
    if (evnt.target === undefined) {
      name = "Optionvalue";
      values = evnt.toString();
    } else {
      if (evnt.target.type === "checkbox") {
        name = evnt.target.name;
        if (evnt.target.checked === true) {
          values = 1;
        } else {
          values = 0;
        }
      } else {
        name = evnt.target.name;
        values = evnt.target.value;
      }
    }

    // console.log(index, name, values);
    const cardInput = [...cardData];
    cardInput[index][name] = values;
    setCardData(cardInput);
  };

  const handleSubmit = () => {
    let data = cardData.filter(function (cardData) {
      return cardData.name != "";
    });

    const jsonobj = {};
    jsonobj.customfieldXml = data;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.employeesBaseUrl}/employees/customfieldupsert`,
        {
          xmlcustomfield: jsonstring,
          loginuserid: Id,
          // attributesxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {

        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
        window.location.reload();
      })
      .catch((error) => {


        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(
        `${config.employeesBaseUrl}/employees/employeescustomgetall?id=${Id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        console.log("dtasssa", response);
        const responseData = response.data.ResponseData?.customefield;
        console.log(responseData);
        if (responseData.length !== 0) {
          setCardData(responseData);
        }

        setLoading(false);
      })
      .catch((err) => {


        setLoading(false);
      });
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div className="page-header"
           style={
            {
              position: "fixed",
              top: "2px",
              zIndex: "999"
            }
          }
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Employees</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/employees">Employees List</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link>Employees Custom Fields</Link>
                </li>
              </ul>
            </div>
          </div>
          <form>
            {/* {divs} */}
            <div className="card">
              <div className="card-body">
                <div className="add">
                  <EmployeeCustomFieldCard
                    cardData={cardData}
                    handleChange={handleChangeCard}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm pull-left mt-2"
                    onClick={addCard}
                  >
                    <i className="fa fa-plus fa-sm p-1" />
                    Add CustomFields
                  </button>
                </div>

                <div className="save pull-right">
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary btn-sm mx-2 mt-2"
                  >
                    {" "}
                    Save
                  </button>
                  <Link
                    to="/employees"
                    className="btn btn-secondary btn-sm me-1 mt-2"
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CustomFieldConfigEmployee;
